import { Effect, Layer, Tuple } from 'effect';
import { GavelConfig } from '../../../../services/gavelConfig';
import { AxiosHttpService, HttpService } from '../../../../services/http';
import { TokenProviderService } from '../../../../services/tokenProvider';
import { PrologRuleAuthoringService } from './authoringService';
import { Create, makeCreateRequestResolver, makeUpdateResolver, Update, } from './gavelService/requests';
const makeGavelPrologRuleAuthoringService = Effect.all(Tuple.make(HttpService, GavelConfig, TokenProviderService)).pipe(
// cache getToken so we produce the same token each time
Effect.flatMap(([http, gavelConfig, tokenProvider]) => Effect.cached(tokenProvider.getToken()).pipe(Effect.map(getToken => [http, gavelConfig, getToken]))), Effect.map(([http, gavelConfig, getToken]) => {
    const baseUrl = gavelConfig.gavelUrl;
    const createResolver = makeCreateRequestResolver(http);
    const create = (tenant, name, body) => getToken.pipe(Effect.flatMap(token => Effect.request(new Create({
        tenant,
        ruleName: name,
        ruleBody: body,
        baseUrl,
        token: `Bearer ${token}`,
    }), createResolver)));
    const update = (tenant, ruleId, ruleName, ruleBody) => getToken.pipe(Effect.flatMap(token => Effect.request(new Update({
        baseUrl,
        ruleBody,
        ruleId,
        ruleName,
        tenant,
        token: `Bearer ${token}`,
    }), makeUpdateResolver(http))));
    return { create, update };
}));
export const BaseGavelPrologRuleAuthoringService = Layer.effect(PrologRuleAuthoringService, makeGavelPrologRuleAuthoringService);
export const DefaultGavelPrologRuleAuthoringService = BaseGavelPrologRuleAuthoringService.pipe(Layer.provide(AxiosHttpService));
